/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Commission_EmphasisInputs */

const es_landing_commission_emphasis = /** @type {(inputs: Landing_Commission_EmphasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tarifa más baja del mercado.`)
};

const gl_landing_commission_emphasis = /** @type {(inputs: Landing_Commission_EmphasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tarifa máis baixa do mercado.`)
};

const en_landing_commission_emphasis = /** @type {(inputs: Landing_Commission_EmphasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The lowest rate on the market.`)
};

/**
* | output |
* | --- |
* | "The lowest rate on the market." |
*
* @param {Landing_Commission_EmphasisInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_commission_emphasis = /** @type {((inputs?: Landing_Commission_EmphasisInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Commission_EmphasisInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_commission_emphasis(inputs)
	if (locale === "en") return en_landing_commission_emphasis(inputs)
	return es_landing_commission_emphasis(inputs)
});